export default __webpack_public_path__ + "static/media/calendar.ff30cc82.svg";